import { i18n } from "@dehub/theme";

import mnLayout from "./locales/mn/layout.json";
import koLayout from "./locales/ko/layout.json";
import enLayout from "./locales/en/layout.json";
import zhLayout from "./locales/zh/layout.json";

import mnCommon from "./locales/mn/common.json";
import koCommon from "./locales/ko/common.json";
import enCommon from "./locales/en/common.json";
import zhCommon from "./locales/zh/common.json";

import mnErrors from "./locales/mn/errors.json";
import koErrors from "./locales/ko/errors.json";
import enErrors from "./locales/en/errors.json";
import zhErrors from "./locales/zh/errors.json";

import mnPartner from "./locales/mn/partner.json";
import koPartner from "./locales/ko/partner.json";
import enPartner from "./locales/en/partner.json";
import zhPartner from "./locales/zh/partner.json";

import mnBusiness from "./locales/mn/business.json";
import koBusiness from "./locales/ko/business.json";
import enBusiness from "./locales/en/business.json";
import zhBusiness from "./locales/zh/business.json";

import mnSector from "./locales/mn/sector.json";
import koSector from "./locales/ko/sector.json";
import enSector from "./locales/en/sector.json";
import zhSector from "./locales/zh/sector.json";

import mnWarehouse from "./locales/mn/warehouse.json";
import koWarehouse from "./locales/ko/warehouse.json";
import enWarehouse from "./locales/en/warehouse.json";
import zhWarehouse from "./locales/zh/warehouse.json";

import mnRegister from "./locales/mn/register.json";
import koRegister from "./locales/ko/register.json";
import enRegister from "./locales/en/register.json";
import zhRegister from "./locales/zh/register.json";

import mnProfile from "./locales/mn/profile.json";
import koProfile from "./locales/ko/profile.json";
import enProfile from "./locales/en/profile.json";
import zhProfile from "./locales/zh/profile.json";

import mnStaff from "./locales/mn/staff.json";
import koStaff from "./locales/ko/staff.json";
import enStaff from "./locales/en/staff.json";
import zhStaff from "./locales/zh/staff.json";

i18n.addResourceBundle("mn", "layout", mnLayout, true, true);
i18n.addResourceBundle("ko", "layout", koLayout, true, true);
i18n.addResourceBundle("en", "layout", enLayout, true, true);
i18n.addResourceBundle("zh", "layout", zhLayout, true, true);

i18n.addResourceBundle("mn", "common", mnCommon, true, true);
i18n.addResourceBundle("ko", "common", koCommon, true, true);
i18n.addResourceBundle("en", "common", enCommon, true, true);
i18n.addResourceBundle("zh", "common", zhCommon, true, true);

i18n.addResourceBundle("mn", "errors", mnErrors, true, true);
i18n.addResourceBundle("ko", "errors", koErrors, true, true);
i18n.addResourceBundle("en", "errors", enErrors, true, true);
i18n.addResourceBundle("zh", "errors", zhErrors, true, true);

i18n.addResourceBundle("mn", "partner", mnPartner, true, true);
i18n.addResourceBundle("ko", "partner", koPartner, true, true);
i18n.addResourceBundle("en", "partner", enPartner, true, true);
i18n.addResourceBundle("zh", "partner", zhPartner, true, true);

i18n.addResourceBundle("mn", "business", mnBusiness, true, true);
i18n.addResourceBundle("ko", "business", koBusiness, true, true);
i18n.addResourceBundle("en", "business", enBusiness, true, true);
i18n.addResourceBundle("zh", "business", zhBusiness, true, true);

i18n.addResourceBundle("mn", "sector", mnSector, true, true);
i18n.addResourceBundle("ko", "sector", koSector, true, true);
i18n.addResourceBundle("en", "sector", enSector, true, true);
i18n.addResourceBundle("zh", "sector", zhSector, true, true);

i18n.addResourceBundle("mn", "warehouse", mnWarehouse, true, true);
i18n.addResourceBundle("ko", "warehouse", koWarehouse, true, true);
i18n.addResourceBundle("en", "warehouse", enWarehouse, true, true);
i18n.addResourceBundle("zh", "warehouse", zhWarehouse, true, true);

i18n.addResourceBundle("mn", "register", mnRegister, true, true);
i18n.addResourceBundle("ko", "register", koRegister, true, true);
i18n.addResourceBundle("en", "register", enRegister, true, true);
i18n.addResourceBundle("zh", "register", zhRegister, true, true);

i18n.addResourceBundle("mn", "profile", mnProfile, true, true);
i18n.addResourceBundle("ko", "profile", koProfile, true, true);
i18n.addResourceBundle("en", "profile", enProfile, true, true);
i18n.addResourceBundle("zh", "profile", zhProfile, true, true);

i18n.addResourceBundle("mn", "staff", mnStaff, true, true);
i18n.addResourceBundle("ko", "staff", koStaff, true, true);
i18n.addResourceBundle("en", "staff", enStaff, true, true);
i18n.addResourceBundle("zh", "staff", zhStaff, true, true);
